import React, { useContext } from "react";
import { AppContext } from "../../contexts/AppContext";

export default function ProjectTitle({ project }) {
  const { sanitize } = useContext(AppContext);
  return (
    <div className="prjdetails-sub-header" style={{top: "78px"}}>
      <nav aria-label="breadcrumb" className="main-breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item" aria-current="page">
            {project.name ? (
              <center className="project-all-info">
                {!sanitize
                  ? `${project?.zohoID}-${project?.clientName}-${project?.name}`
                  : `${project?.zohoID}- Sanitized Mode - ${
                      project?.name.split("-")[1]
                    }`}
              </center>
            ) : <center><i class="fa-solid fa-spinner fa-spin"></i></center>}
          </li>
        </ol>
      </nav>
    </div>
  );
}
